var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    attrs: {
      value: _vm.value,
      items: _vm.oldHeaderNameItems,
      fancy: "",
      open: "",
      label: _vm.label,
    },
    on: {
      input: function ($event) {
        return _vm.setValue($event)
      },
      blur: function ($event) {
        return _vm.onAutocompleteBlur()
      },
      "item-click": function ($event) {
        return _vm.setValue($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [_vm._v(" " + _vm._s(p.item) + " ")]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }